import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Link } from "react-router-dom";

import { Navigate } from 'react-router-dom';
import { Card,
         Page,
         Text,
         Divider,
         Select,
         Button,
         ResourceList,
         ResourceItem,
         Thumbnail,
         Box,
         EmptyState,
         Banner,
         BlockStack,
         InlineStack,
         ButtonGroup,
         Icon,
         Badge,
         DescriptionList
       } from '@shopify/polaris';
import { useAppBridge } from '@shopify/app-bridge-react';
import {
  ProductIcon,
  SaveIcon
} from '@shopify/polaris-icons';

// import PrintLine from "./PrintLine";
import ModifyCountDialog from './ModifyCountDialog';
import NoLabelTemplatesBox from '../partials/NoLabelTemplatesBox';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageFooter from '../partials/PageFooter';
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import { indexBarcodeTemplates } from '../../redux/actions/barcodeTemplates';
import { requestPrint } from '../../redux/actions/prints';

const PrintBarcodes = ({ shopUrl, payload, getTemplates, selectedVariantList, barcodeTemplates, postPrint, downloadUrl, prints, missingBarcodes, requiresRefresh }) => {
  const [submitted, setSubmitted] = useState(false);
  const [activeTemplate, setActiveTemplate] = useState({});
  const [printOrder, setPrintOrder] = useState('default');
  const [modifyItem, setModifyItem] = useState(null);
  const [modifyType, setModifyType] = useState(null);
  const [modifyCount, setModifyCount] = useState(null);
  const [modifyItemId, setModifyItemId] = useState(null);
  const [showPrintCountDialog, setShowPrintCountDialog] = useState(false);
  const [labelCount, setLabelCount] = useState(0);
  const [printCounts, setPrintCounts] = useState({});

  const [templateList, setTemplateList] = useState([]);

  const switchActiveTemplate = (event) => {
    let template = barcodeTemplates.templates.find(template => template.uuid === event);
    setActiveTemplate(template);
  }

  const switchPrintOrder = (event) => {
    setPrintOrder(event);
  }

  const setPrintCount = (itemId, modifyItem, count) => {
    let tempCounts = printCounts;

    tempCounts[itemId] = {
      count: count,
      item: modifyItem
    };

    setPrintCounts(tempCounts);
    calculateTotal();
  }

  const calculateTotal = () => {
    let tempTotal = 0;

    selectedVariantList.map((variant) => {
      tempTotal = tempTotal + (parseInt(printCounts[variant.id]?.count) || 0)
    })

    setLabelCount(tempTotal);
  }


  const setAllToZero = () => {
    let tempCounts = {};

    selectedVariantList.forEach((variant) =>
      tempCounts[variant.id] = {
        count: 0,
        item: variant
      }
    )

    setPrintCounts(tempCounts);
  }

  const setAllToOne = () => {
    let tempCounts = {};

    selectedVariantList.forEach((variant) =>
      tempCounts[variant.id] = {
        count: 1,
        item: variant
      }
    )

    setPrintCounts(tempCounts);
  }

  const setAllToInventory = () => {
    let tempCounts = {};

    selectedVariantList.forEach((variant) =>
      tempCounts[variant.id] = {
        count: variant.quantity,
        item: variant
      }
    )

    setPrintCounts(tempCounts);
  }

  const download = () => {
    postPrint(shopUrl, payload, activeTemplate.uuid, printCounts, printOrder);
    setSubmitted(true);
  }

  const setAndShowDialog = (item) => {
    setModifyItem(item);
    setModifyItemId(item.id);
    shopify.modal.show('print-count-modal');
  }

  useEffect(() => {
    getTemplates(shopUrl, payload);
    setAllToZero();
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [printCounts]);

  useEffect(() => {
    if(downloadUrl && submitted) { 
      let win = window.open(downloadUrl, '_blank');
      win.focus();
      setSubmitted(false);
    }
  }, [downloadUrl]);

  useEffect(() => {
    if (barcodeTemplates.status === 'success' && barcodeTemplates.templates.length > 0) {
      let tempList = [];

      barcodeTemplates.templates.forEach((template) => {
        tempList.push({ label: template.template_name, value: template.uuid });
      });

      setTemplateList(tempList);
      setActiveTemplate(barcodeTemplates.templates[0]);
    }
  }, [barcodeTemplates]);

  const optionBadge = (option) => {
    return <div key={option.name}>
      <Badge 
        tone="info"
        key={option.name}
      >
        <Text>{option.value}</Text>
      </Badge>
       &nbsp;
    </div>
  }

  return(
    <Page
      title="Print Labels"
      backAction={{content: 'Back', url: 'https://' + window.location.hostname + '/manage' + window.location.search}}
    >
      { requiresRefresh &&
        <RequiresRefreshBanner />
      }
      <BlockStack gap="400">
        <Card>
          <Text variant="headingLg" as="h5">Print Template</Text>
          
          <Box padding="400">
            { barcodeTemplates.templates.length > 0 && barcodeTemplates.status === 'success' &&
              <DescriptionList
                items={[
                  {
                    term: 'Templates',
                    description:
                      <Select
                        options={templateList}
                        onChange={switchActiveTemplate}
                        value={activeTemplate.uuid}
                        placeholder="Select print template"
                      />   
                  },
                  {
                    term: 'Print Order',
                    description:
                      <Select
                        options={[
                          {label: 'Set print order', value: 'default', disabled: true},
                          {label: 'SKU', value: 'sku'},
                          {label: 'Barcode', value: 'barcode'},
                          {label: 'Product Name', value: 'product'}
                        ]}
                        onChange={switchPrintOrder}
                        value={printOrder}
                      />
                  }
                ]}
              />
            }

            { barcodeTemplates.status === 'success' && barcodeTemplates.templates.length === 0 && 
              <NoLabelTemplatesBox />
            }

            { barcodeTemplates.status !== 'success' &&
              <DescriptionList
                items={[
                  {
                    term: 'Templates',
                    description:
                      <LoadingSpinner size="small" statusText="Loading templates" /> 
                  },
                  {
                    term: 'Print Order',
                    description:
                      <LoadingSpinner size="small" />
                  }
                ]}
              />
            }
          </Box>

          <Divider borderColor="border" />

          <Box padding="400">
            { activeTemplate?.uuid && (labelCount > 0) && (prints.status !== "requesting") && 
              <div className="top-15">
                <Banner tone="warning">
                  <p>
                    Please ensure your browser allows popups for this page when downloading your print file.
                  </p>
                </Banner>

                <Button icon={SaveIcon} variant="primary" onClick={() => download()}>
                  Confirm and Download Print File
                </Button>              
              </div>
            }

            { (!activeTemplate.uuid || (labelCount === 0)) && (prints.status !== "requesting") && 
              <Button icon={SaveIcon} disabled>Confirm and Download Print File</Button>
            }

            { prints.status === "requesting" &&
              <LoadingSpinner size="small" statusText="Generating print file" />
            }
          </Box>
        </Card>

        <Card>
          <BlockStack gap="200">
            <Text variant="headingLg" as="h5">Product Label Counts</Text>
            <Text variant="headingMd" as="h6">
              Quick quantity set options
            </Text>

            <InlineStack align="end">
              <ButtonGroup>
                <Button onClick={() => setAllToZero()}>Set All to 0</Button>&nbsp;
                <Button onClick={() => setAllToOne()}>Set All to 1</Button>&nbsp;
                <Button variant="primary" onClick={() => setAllToInventory()}>Set All to Quantity In Stock</Button>
              </ButtonGroup>
            </InlineStack>

            <Divider />

            <Text variant="headingMd" as="h6">
              Selected products
            </Text>

            <ResourceList
              resourceName={{singular: 'count', plural: 'counts'}}
              items={selectedVariantList}
              renderItem={(item) => {
                const media = <Thumbnail size="small" source={item?.featuredMedia?.preview?.image?.url} alt={item?.featuredMedia?.alt} />;

                return (
                  <ResourceItem
                    key={item.id}
                    id={item.id}
                    url={'#'}
                    onClick={() => setAndShowDialog(item)}
                    media={item?.featuredMedia?.preview?.image?.url ? media : <Icon source={ProductIcon} tone="base" />}
                    accessibilityLabel={`View print count options for ${item.name}`}
                  >
                    <Text variant="bodyMd" fontWeight="bold" as="h3">
                      {item.name}
                    </Text>
                    <Text>
                      {(item.options ? item.options.map((option) => optionBadge(option)) : '')}
                    </Text>
                    <Text>
                      Inventory: {item.quantity}
                    </Text>
                    <Text>
                      ---
                    </Text>
                    <Text>
                      <strong>Print Count</strong>: {printCounts[item.id]?.count || 0}
                    </Text>
                  </ResourceItem>
                );
              }}
            >
            </ResourceList>

            { selectedVariantList?.length === 0 &&
              <EmptyState
                heading="No Products Selected"
                image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
              >
                <p>
                  <Link to={`/manage${window.location.search}`}>
                    Search and select products for label printing.
                  </Link>
                </p>
              </EmptyState>
            }
          </BlockStack>
        </Card>

        <PageFooter stripeBackground='#070808' helpLink="inventory-management/print-barcode-labels-3/" helpDescription="printing labels" />

      </BlockStack>

      <ModifyCountDialog
        shopify={shopify}
        modifyItemId={modifyItemId}
        modifyItem={modifyItem}
        printCounts={printCounts}
        setPrintCount={setPrintCount}
      />
    </Page>
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  selectedVariantList: state.products.selectedVariantList,
  missingBarcodes: state.products.missingBarcodes,
  barcodeTemplates: state.barcodeTemplates,
  prints: state.prints,
  downloadUrl: state.prints.downloadUrl,
});

const mapDispatchToProps = (dispatch) => ({
  getTemplates: (shopUrl, payload) => dispatch(indexBarcodeTemplates(shopUrl, payload)),
  postPrint: (shopUrl, payload, template, printCounts, printOrder) => dispatch(requestPrint(shopUrl, payload, template, printCounts, printOrder)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintBarcodes);
